import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        /*{
          path: '/',
          redirect: '/homeENG'
        },*/
        {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        },
        {
          path: '/',
          name: 'homeENG',
          component: resolve => require(['@/view/HomePageENG'], resolve),
          meta: {
            title: 'sutor'
          }
        },
        {
          path: '/studycenter',
          name: 'studycenter',
          component: resolve => require(['@/view/StudyCenter'], resolve),
          meta: {
            title: '研发中心'
          }
        },
        {
          path: '/studycenterENG',
          name: 'studycenterENG',
          component: resolve => require(['@/view/StudyCenterENG'], resolve),
          meta: {
            title: 'R&D CENTER'
          }
        },
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/contactusENG',
          name: 'contactusENG',
          component: resolve => require(['@/view/ContactUsENG'], resolve),
          meta: {
            title: 'CONTACT US'
          }
        },
        {
          path: '/QuotationENG',
          name: 'QuotationENG',
          component: resolve => require(['@/view/Quotation'], resolve),
          meta: {
            title: 'Quotation'
          }
        },
        {
          path: '/productserve',
          name: 'productserve',
          component: resolve => require(['@/view/ProductServe'], resolve),
          meta: {
            title: '产品与服务'
          },
          children: [
            {
              path: '/productserve',
              redirect: '/productserve/suanxi'
            },
            {
              path: '/productserve/suanxi',
              name: 'suanxi',
              component: resolve => require(['@/view/proAser/Suanxi'], resolve),
              meta: {
                title: '酸洗产品'
              }
            },
            {
              path: '/productserve/lenzha',
              name: 'lenzha',
              component: resolve => require(['@/view/proAser/Lenzha'], resolve),
              meta: {
                title: '冷轧产品'
              }
            },
            {
              path: '/productserve/reduxin',
              name: 'reduxin',
              component: resolve => require(['@/view/proAser/Reduxin'], resolve),
              meta: {
                title: '热镀锌产品'
              }
            },
            {
              path: '/productserve/caitu',
              name: 'caitu',
              component: resolve => require(['@/view/proAser/Caitu'], resolve),
              meta: {
                title: '彩涂产品'
              }
            },
            {
              path: '/productserve/gangguan',
              name: 'gangguan',
              component: resolve => require(['@/view/proAser/Gangguan'], resolve),
              meta: {
                title: '钢管产品'
              }
            },
            {
              path: '/productserve/jiagong',
              name: 'jiagong',
              component: resolve => require(['@/view/proAser/Jiagong'], resolve),
              meta: {
                title: '加工服务'
              }
            }
          ]
        },
        {
          path: '/adminLogin',
          name: 'adminLogin',
          component: resolve => require(['@/view/Login'], resolve),
          meta: {
            title: '登录'
          }
        },
        {
          path: '/productserveENG',
          name: 'productserveENG',
          component: resolve => require(['@/view/ProductServeENG'], resolve),
          meta: {
            title: 'PRODUCTS & SERVICES'
          },
          children: [
            {
              path: '/productserveENG',
              redirect: '/productserveENG/suanxiENG'
            },
            {
              path: '/productserveENG/suanxiENG',
              name: 'suanxiENG',
              component: resolve => require(['@/view/proAserENG/Suanxi'], resolve),
              meta: {
                title: 'Acid Pickled'
              }
            },
            {
              path: '/productserveENG/lenzhaENG',
              name: 'lenzhaENG',
              component: resolve => require(['@/view/proAserENG/Lenzha'], resolve),
              meta: {
                title: 'Cold Rolled'
              }
            },
            {
              path: '/productserveENG/reduxinENG',
              name: 'reduxinENG',
              component: resolve => require(['@/view/proAserENG/Reduxin'], resolve),
              meta: {
                title: 'Hot-dip Galvanized'
              }
            },
            {
              path: '/productserveENG/caituENG',
              name: 'caituENG',
              component: resolve => require(['@/view/proAserENG/Caitu'], resolve),
              meta: {
                title: 'Pre-Painted'
              }
            },
            {
              path: '/productserveENG/gangguanENG',
              name: 'gangguanENG',
              component: resolve => require(['@/view/proAserENG/Gangguan'], resolve),
              meta: {
                title: 'Steel Pipe'
              }
            },
            {
              path: '/productserveENG/jiagongENG',
              name: 'jiagongENG',
              component: resolve => require(['@/view/proAserENG/Jiagong'], resolve),
              meta: {
                title: 'Extended processing services'
              }
            }
          ]
        },
        {
          path: '/fileUpload',
          name: 'fileUpload',
          component: resolve => require(['@/view/file/FileManage'], resolve),
          meta: {
            title: 'fileupload'
          }
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js